import Swiper from 'swiper/dist/js/swiper';
import onDocumentReady from '../utilities/onDocumentReady';

onDocumentReady(() => {
    let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let slider;

    function initSlider() {
        const sliderContainer = document.querySelector('.index-slider .swiper-container');
        if (sliderContainer) {
            slider = new Swiper(sliderContainer, {
                autoplay: {
                    delay: 5000,
                },
                loop: true,
                speed: 600,
                spaceBetween: 0,
                pagination: {
                    el: '.index-slider-control__pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.index-slider-control__button--next',
                    prevEl: '.index-slider-control__button--prev',
                },
                breakpoints: {
                    768: {
                        pagination: {
                            el: '.index-slider-control__pagination--mobile',
                            type: 'bullets',
                            clickable: true,
                            dynamicBullets: true,
                            dynamicMainBullets: 1
                        },
                    },
                },
                centeredSlides: true,
            });

            slider.slideTo(1, false, false);
        }
    }

    initSlider();
});
